export type RaidCriticalityBand = "Critical" | "High" | "Medium" | "Low";

/**
 * Converts the source RAID risk score into the rating used by the originating
 * register. Scores use the standard 5×5 matrix: 16–25 Critical, 11–15 High,
 * 6–10 Medium, and 1–5 Low. Text source values are retained as-is.
 */
export function resolveRaidCriticality(value: string | null | undefined): RaidCriticalityBand | null {
  const normalized = value?.trim().toLowerCase() ?? "";
  if (!normalized) return null;

  if (/\bcritical\b/.test(normalized)) return "Critical";
  if (/\b(high|severe)\b/.test(normalized)) return "High";
  if (/\b(medium|moderate)\b/.test(normalized)) return "Medium";
  if (/\b(low|minor)\b/.test(normalized)) return "Low";

  const score = Number(normalized);
  if (!Number.isFinite(score)) return null;
  if (score >= 16 && score <= 25) return "Critical";
  if (score >= 11 && score <= 15) return "High";
  if (score >= 6 && score <= 10) return "Medium";
  if (score >= 1 && score <= 5) return "Low";
  return null;
}
